import { render, staticRenderFns } from "./StatusView.vue?vue&type=template&id=37b6a8a4&scoped=true&"
import script from "./StatusView.vue?vue&type=script&lang=js&"
export * from "./StatusView.vue?vue&type=script&lang=js&"
import style0 from "./StatusView.vue?vue&type=style&index=0&id=37b6a8a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b6a8a4",
  null
  
)

export default component.exports